import React from 'react';
import Enemies from '../Enemies';
import Details from '../Details';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import useSparkSyncSuspendEnable, {
  UseSparkSyncSuspendEnableReturn,
} from 'src/SharedCustomHooks/UseSparkSync/useSparkSyncSuspendEnable';
import SparkSyncSuspendButton from 'src/components/HeadingWithDetails/Components/SparkSyncButton';
import './HeadingWithDetails.scss';

interface HeadingWithDetailsProps {
  headline?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  actions?: React.ReactNode;
  toast?: React.ReactNode;
  items?: React.ReactNode[];
  status?: string;
  style?: React.CSSProperties;
  filedIn?: any;
  propertyId?: string;
  compact?: boolean;
  aside?: React.ReactNode;
}

const HeadingWithDetails = ({
  actions,
  breadcrumb,
  status,
  headline,
  items,
  style,
  toast,
  filedIn,
  propertyId,
  compact = false,
  aside,
}: HeadingWithDetailsProps) => {
  const {
    isSpark,
    sparkSyncSuspended,
    isTogglingSuspend,
    isConfirmModalOpen,
    openSuspendConfirmModal,
    closeConfirmModal,
    confirmSuspendAction,
    confirmModalProps,
  }: UseSparkSyncSuspendEnableReturn = useSparkSyncSuspendEnable(propertyId);

  const showSparkSyncButtons: boolean = propertyId && isSpark;

  return (
    <div className="heading-with-details">
      {style && <div className="heading-with-details-image" style={style} />}
      <div className={`heading-with-details-wrapper${compact ? ' heading-with-details-wrapper-compact' : ''}`}>
        {breadcrumb && (
          <div className="heading-with-details-breadcrumb">{breadcrumb}</div>
        )}
        <div
          className={
            status === 'On Hold'
              ? 'heading-with-details-body-yellow'
              : 'heading-with-details-body'
          }
        >
          {toast && <div className="heading-with-details-top">{toast}</div>}
          <div className="heading-with-details-bottom">
            {aside ? (
              <div className="heading-with-details-bottom-row">
                <div className="heading-with-details-bottom-main">
                  <Enemies>
                    {headline && (
                      <div className="heading-with-details-headline">{headline}</div>
                    )}
                  </Enemies>
                  {filedIn && <div>Filed in: {filedIn}</div>}
                </div>
                <div className="heading-with-details-bottom-aside">{aside}</div>
              </div>
            ) : (
              <>
                <Enemies>
                  {headline && (
                    <div className="heading-with-details-headline">{headline}</div>
                  )}
                </Enemies>
                {filedIn && <div>Filed in: {filedIn}</div>}
              </>
            )}
            {actions && (
              <div className="heading-with-details-actions">
                {showSparkSyncButtons && (
                  <SparkSyncSuspendButton
                    sparkSyncSuspended={sparkSyncSuspended}
                    isTogglingSuspend={isTogglingSuspend}
                    onToggleSuspend={openSuspendConfirmModal}
                  />
                )}
                {actions}
              </div>
            )}
            <div className="heading-with-details-details">
              <Details items={items?.filter((item: any) => item)} />
            </div>
          </div>
        </div>
      </div>
      {isConfirmModalOpen && (
        <ConfirmationModal
          title={confirmModalProps.title}
          message={confirmModalProps.message}
          confirmLabel={confirmModalProps.confirmLabel}
          cancelLabel={confirmModalProps.cancelLabel}
          variant={confirmModalProps.variant}
          requireTypeToConfirm={confirmModalProps.requireTypeToConfirm}
          confirmationWord={confirmModalProps.confirmationWord}
          onConfirm={confirmSuspendAction}
          onCancel={closeConfirmModal}
          isSubmitting={isTogglingSuspend}
        />
      )}
    </div>
  );
};

export default HeadingWithDetails;
